import { render, staticRenderFns } from "./DispatchDeliveryCompanySelect.vue?vue&type=template&id=f8df6f12&scoped=true&lang=pug"
import script from "./DispatchDeliveryCompanySelect.vue?vue&type=script&lang=js"
export * from "./DispatchDeliveryCompanySelect.vue?vue&type=script&lang=js"
import style0 from "./DispatchDeliveryCompanySelect.vue?vue&type=style&index=0&id=f8df6f12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8df6f12",
  null
  
)

export default component.exports